import axios from 'axios'
import router from '@/router'
import Configuration from '@/utils/configuration'

const state = {
  auth_data: localStorage.getItem('auth_data'),
  user_data: localStorage.getItem('user_data'),
  error: null
}

const mutations = {
  LOGIN_SUCCESS (state, data) {
    state.user_data = data.userData
    state.auth_data = data.authData
    state.error = null
  },

  LOGIN_FAILURE (state, error) {
    state.auth_data = null
    state.user_data = null
    state.error = error
  },

  LOGOUT (state) {
    state.auth_data = null
    state.user_data = null
    state.error = null
  }
}

const actions = {
  login (context, data) {
    if (data.authData) {
      let plainAuthData = data.authData
      const requestConfig = {
        headers: {
          'Authorization': 'Bearer ' + plainAuthData.access_token
        }
      }

      const protocol = Configuration.value('backendProtocol')
      const host = Configuration.value('cloudUserAPIHost')
      const responseUserInfoPromise = axios.post(protocol + '://' + host + '/info', {}, requestConfig)

      responseUserInfoPromise.then(function (response) {
        let userData = JSON.stringify(response.data)
        localStorage.setItem('user_data', userData)
        localStorage.setItem('auth_data', JSON.stringify(data.authData))
        context.commit('LOGIN_SUCCESS', { authData: data.authData, userData: userData })
      })

      return responseUserInfoPromise
    } else {
      context.commit('LOGIN_FAILURE', 'Authorization fail')
    }
  },

  logout (context) {
    localStorage.removeItem('auth_data')
    localStorage.removeItem('user_data')
    context.commit('LOGOUT')
    router.push('/')
  }
}

const getters = {
  token: state => {
    if (state.auth_data) {
      try {
        const authDataJson = JSON.parse(state.auth_data)
        return authDataJson.access_token
      } catch (e) {
        return null
      }
    }

    return null
  },

  currentUser: state => {
    if (state.user_data) {
      try {
        return JSON.parse(state.user_data)
      } catch (e) {
        return null
      }
    }

    return null
  },

  features: state => {
    const userData = JSON.parse(state.user_data)
    return userData.features
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
